(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/dialog/assets/javascripts/areas/popup-area.js') >= 0) return;  svs.modules.push('/components/components/dialog/assets/javascripts/areas/popup-area.js'); "use strict";


(function (svs, gsap) {
  'use strict';

  svs = svs || {};
  svs.components = svs.components || {};
  svs.components.dialog = svs.components.dialog || {};

  class DialogPopupsArea extends svs.components.dialog.PubSub {
    constructor(options) {
      super();
      this.log = new svs.core.log.Logger('DialogPopupsArea');
      this.name = svs.components.dialog.area.POPUP;
      this.items = [];
      this.el = options.el;
      this.options = options;
      this.at = 0;
      this.hasRendered = false;
      this.isOpen = false;
      this.offsetHeight = 50;
      this.init();
    }

    init() {
      this.el = document.createElement('div');
      this.el.className += 'js-dialog-items dialog-items js-dialog-popup-items dialog-popup-items focus-inverted';
      this.el.setAttribute('role', 'dialog');
      this.el.setAttribute('tabindex', '0');
      this.options.attachTo.appendChild(this.el); 

      const accessibilityOptions = {
        el: this.el,
        type: svs.components.dialog.area.POPUP,
        activeElBeforeOpen: document.activeElement,
        attachTo: this.options.attachTo
      };
      this.accessibility = new svs.components.dialog.Accessibility(accessibilityOptions);
      window.addEventListener('resize', () => {
        this.resize();
      });
      window.addEventListener('orientationchange', () => {
        setTimeout(() => {
          this.resize();
        }, 400);
      });

      if (window.ResizeObserver !== undefined) {
        this.resizeObserver = new ResizeObserver(() => {
          this.resize();
        });
      }
    }

    resize() {
      const currentItem = this.items[0];

      if (currentItem) {
        const windowH = this.getWindowAvialiableHeight();
        currentItem.setScrollableHeight('auto');

        if (windowH > currentItem.el.offsetHeight) {
          currentItem.setScrollableHeight('auto'); 

          gsap.set(this.el, {
            height: currentItem.el.clientHeight
          });
        } else {
          currentItem.setScrollableHeight(windowH); 

          gsap.set(this.el, {
            height: windowH
          });
        }
      }
    }

    add(dialog) {
      if (dialog) {
        let itemsToAdd = []; 

        const toasters = this.options.areas[svs.components.dialog.area.TOASTER]; 

        if (toasters && toasters.count()) {
          this.log.debug('Converted all toasters to popups');
          itemsToAdd = toasters.convertToPopups() || [];
        } 


        itemsToAdd.push(dialog);
        itemsToAdd.forEach(dialog => {
          dialog.el.className += ' dialog-popup-item';
          this.append(dialog);
        }); 

        if (!this.isOpen) {
          this.open();
        }
      }
    }

    getWindowAvialiableHeight() {
      return window.innerWidth > 620 ? window.innerHeight - 48 : window.innerHeight - 24;
    }

    getNeededHeight() {
      if (this.getWindowAvialiableHeight() > this.items[0].height) {
        return this.items[0].height;
      }

      return this.getWindowAvialiableHeight();
    }

    getHeight() {
      if (window.innerHeight < this.items[0].height) {
        return window.innerHeight;
      }

      return this.items[0].height;
    }

    open() {
      this.isOpen = true;
      this.log.debug('First dialog to be opened');
      this.el.classList.remove('dialog-items-closed');
      this.emit('open', {
        area: this.area
      });
      this.emit('changed', this.items[0]);
      this.resize();
      const tl = gsap.timeline();
      tl.fromTo(this.el, {
        opacity: 0,
        scale: 0.8,
        height: this.getNeededHeight()
      }, {
        duration: 0.15,
        opacity: 1,
        scale: 1,
        ease: 'power1.out',
        height: this.getNeededHeight(),
        onComplete: () => {
          this.items[0].reveal();
        }
      });
      tl.fromTo(this.el, {
        boxShadow: '0'
      }, {
        duration: 0.2,
        boxShadow: '0 0 48px 4px rgba(0, 0, 0, .5)'
      });
    }

    next() {
      this.emit('changed', this.items[0]);
      this.log.debug('Next dialog to be opened');
      gsap.to(this.el, {
        duration: 0.15,
        height: this.getHeight(),
        onComplete: () => {
          this.resize();
          this.items[0].next();
        }
      });
    }

    closeFromOutside(e) {
      const item = this.items[0]; 

      if (item) {
        const actions = item.options.actions;

        if (actions.length === 1 && typeof actions[0].callback === 'function' && e) {
          actions[0].callback(e, item.el.getElementsByClassName('js-dialog-item-checkbox'), item);
        } else {
          this.items[0].close();
        }
      }
    }

    close() {
      this.log.debug('No more dialogs here, close container');
      this.accessibility.removeListeners();

      if (this.resizeObserver !== undefined) {
        this.resizeObserver.disconnect();
      }

      gsap.to(this.el, {
        duration: 0.2,
        boxShadow: 0,
        opacity: 0,
        scale: 0.9,
        delay: 0.1,
        onComplete: () => {
          this.el.classList.add('dialog-items-closed');
          this.isOpen = false;
          this.accessibility.activeElBeforeOpen.focus();
          this.emit('close', {
            area: this.area
          });
          this.log.debug('Container closed!'); 

          if (this.items.length) {
            this.open();
          }
        }
      });
    }

    append(dialog) {
      this.log.debug('Append dialog to be opened');
      dialog._queue = this;
      dialog.area = this.name;
      dialog.on('closed', this, () => {
        this.log.debug('A dialog was closed, now handle it.');
        this.unload(dialog);
      });
      dialog.on('revealed', this, () => {
        this.log.debug('A dialog was revealed.'); 

        setTimeout(() => {
          this.accessibility.focusElement(this.el);
        }, 1);
      });

      if (this.items.length && this.items[0].requireHandshake) {
        this.items.splice(1, 0, dialog);

        if (this.el.children.length > 1) {
          this.el.insertBefore(dialog.el, this.el.children[1]);
        } else {
          this.el.appendChild(dialog.el);
        }
      } else {
        this.items.push(dialog);
        this.el.appendChild(dialog.el);
      }

      if (this.resizeObserver !== undefined) {
        this.resizeObserver.observe(dialog._content._icon.el);
      }

      dialog.setDimensions();
      dialog.setupAnimations();
    }

    unload(dialog) {
      this.items.forEach((item, i) => {
        if (item._id === dialog._id) {
          if (this.resizeObserver !== undefined) {
            this.resizeObserver.unobserve(item._content._icon.el);
          }

          this.items.splice(i, 1);
          this.el.removeChild(item.el);
        }
      });

      if (!this.items.length) {
        this.close();
      } else {
        this.next();
        this.status();
      }
    }

    status() {
      this.log.debug("".concat(this.name, " queue, ").concat(this.items.length, " still remain"));
    }

    count() {
      return this.items.length;
    }

  }

  svs.components.dialog.DialogPopupsArea = DialogPopupsArea;
  svs.components.dialog.area = svs.components.dialog.area || {};
  svs.components.dialog.area.POPUP = 'popup';
  svs.components.dialog.areas = svs.components.dialog.areas || {};
  svs.components.dialog.areas[svs.components.dialog.area.POPUP] = svs.components.dialog.DialogPopupsArea;
})(svs, gsap);
 })(window);